// removed by extract-text-webpack-plugin
module.exports = {"item":"CYxoVJwvpODX8FWP_wkMK","title":"_1yl870RvPADhg2yc5aT9Ov","burger":"_2n9GBpkU9Obd11xT9r2S-b","companyLogo":"_1NN6OyY9TqJtfl5LHAg5MT","elevatorName":"_35j5hj84pwB8MrC7X7jfqm","costContainer":"_3M1TOjh1uHH3B-Ta53dWhd","cost":"_3Lcd-qvamhlc_24mNT1c6q","score":"x-KD25D2ckGvERwMplwp0","scoreDropDown":"_1S-t6rXoan0ePLZDhUmznX","scoreDropDownTrigger":"_2qQ7UlcGGghnZH2RGrDLj9"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Menu/index.css
// module id = 174
// module chunks = 0